import React, { useRef } from 'react';
import * as THREE from 'three';

import Apple from '../../../../../common/components/glb/Apple';
import useFallAnimation from './useFallAnimation';
import useConvergeAnimation from '../useConvergeAnimation';
import useFloatAnimation from '../useFloatAnimation';

const FallApples = () => {
  const uno = { outer: useRef<THREE.Group>(null), inner: useRef<THREE.Group>(null), junction: useRef(new THREE.Vector3(-0.85, -11.6, 0)) };
  const dos = { outer: useRef<THREE.Group>(null), inner: useRef<THREE.Group>(null), junction: useRef(new THREE.Vector3(1.2, -9.2, -0.5)) };

  useFallAnimation(
    { ref: uno.inner, target: uno.junction.current.y },
    { ref: dos.inner, target: dos.junction.current.y }
  );

  useConvergeAnimation([
    { ref: uno.inner, origin: uno.junction },
    { ref: dos.inner, origin: dos.junction }
  ]);

  useFloatAnimation([uno.outer, dos.outer]);

  return (
    <>
      <group ref={uno.outer}>
        <Apple ref={uno.inner} scale={2.0} type="full" position={[uno.junction.current.x, 5, uno.junction.current.z]} rotation={[0.5, 1, 0.3]} />
      </group>

      <group ref={dos.outer}>
        <Apple ref={dos.inner} scale={2.0} type="full" position={[dos.junction.current.x, 5, dos.junction.current.z]} rotation={[0.1, -1.1, -0.7]} />
      </group>
    </>
  );
}

export default FallApples;